import { ColumnType } from 'src/components/molecules/TableRow';

export const TABLE_ROW_HEIGHT = 72;
export const TABLE_HEADER_HEIGHT = 56;
export const TABLE_MAX_VISIBLE_ROWS = 6;
export const MIN_TABLE_HEIGHT =
  TABLE_MAX_VISIBLE_ROWS * TABLE_ROW_HEIGHT + TABLE_HEADER_HEIGHT;
export const STATUS_COLUMN_WIDTH = '90px';
export const ACTION_COLUMN_WIDTH = '80px';

export const ITEMS_PER_PAGE_OPTIONS = [
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
];

export const CATEGORY_DETAILS_COLUMNS: ColumnType[] = [
  { label: 'Form Title', value: 'formTitle' },
  { label: 'Category', value: 'category' },
  { label: 'Languages', value: 'languages' },
  { label: 'Questions', value: 'questions' },
  { label: 'Created by', value: 'createdBy' },
  { label: 'Created at', value: 'createdAt' },
  { label: 'Last Updated', value: 'lastUpdated' },
  { label: 'Status', value: 'status' },
  { label: 'Action', value: 'action', showOverflow: true },
];
